import {
  ThemeProvider,
  TypographyProvider,
} from "@commerce-core/react-components";
import { ErrorState } from "@/components/ErrorState";
import { LoadingState } from "@/components/LoadingState";
import { SectionRenderer } from "@/components/SectionRenderer";
import { useCleanHashScroll } from "@/hooks/useCleanHashScroll";
import { useVideoPageBuilderData } from "@/hooks/useVideoPageBuilderData";
import "./global.css";

function App() {
  useCleanHashScroll();

  const { data, error, isLoading } = useVideoPageBuilderData();

  if (isLoading) {
    return <LoadingState />;
  }

  if (error || !data) {
    return <ErrorState message={error ?? "Video page data is unavailable."} />;
  }

  const themeVariables = data.variables as Record<string, string>;

  return (
    <TypographyProvider preset={data.typographyPreset}>
      <ThemeProvider variables={themeVariables}>
        <main>
          {data.sections.map((section, index) => (
            <SectionRenderer
              section={section}
              key={`${section.acf_fc_layout}-${index}`}
            />
          ))}
        </main>
      </ThemeProvider>
    </TypographyProvider>
  );
}

export default App;
